import { Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CurrencyPipe, NgIf } from '@angular/common';
import { ProductModel } from '../../../core/models/product.model';
import { CartService } from '../../../core/services/cart.service';
import { QuoteService } from '../../../core/services/quote.service';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [RouterLink, CurrencyPipe, NgIf],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent {
  @Input() p!: ProductModel;
  cart = inject(CartService);
  quote = inject(QuoteService);

  addToCart()  { this.cart.add(this.p, 1); }
  addToQuote() { this.quote.add(this.p); }
}
